// extracted by mini-css-extract-plugin
module.exports = {"UserProfile":"UserProfile_UserProfile__3ZmA1","UserProfile__Imagen":"UserProfile_UserProfile__Imagen__47GK-","UserProfile__OnClick":"UserProfile_UserProfile__OnClick__3ue7p"};